import React from 'react';

import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import { EstimationsSubForm } from '../forms';
import st from './VerifierStep.module.sass';

const StepSelectionOfAttribute = () => {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('verifiers:form.stepTitles.step2')}
        </StepTitle>
      )}
    >
      <EstimationsSubForm />
    </Step>
  );
};

StepSelectionOfAttribute.fieldNames = [
  'estimate',
  'extract',
];

export { StepSelectionOfAttribute };
